export enum CoverageActionType {
    New = 1,
    Edit = 2,
    ReadOnly = 3,
    ReNew = 4
}
